
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M19.795 5.618C17.83 2.15 14.079 0 10.002 0 5.925 0 2.171 2.15.206 5.618a1.582 1.582 0 000 1.56C2.17 10.645 5.92 12.8 9.998 12.8s7.828-2.155 9.793-5.622c.278-.481.278-1.079.004-1.56zm-.517 1.263c-1.858 3.279-5.414 5.317-9.276 5.317S2.584 10.16.727 6.881a.988.988 0 010-.963C2.584 2.64 6.14.603 10.002.603s7.418 2.038 9.276 5.316a.988.988 0 010 .963z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M10.002 1.926c-2.446 0-4.435 2.006-4.435 4.474 0 2.468 1.99 4.474 4.435 4.474 2.446 0 4.435-2.006 4.435-4.474 0-2.468-1.989-4.474-4.435-4.474zm0 8.346c-2.116 0-3.838-1.737-3.838-3.872s1.722-3.872 3.838-3.872S13.84 4.265 13.84 6.4s-1.722 3.872-3.838 3.872z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M11.887 5.164a.308.308 0 00-.143.401c.124.261.187.542.187.835a1.942 1.942 0 01-1.929 1.946A1.942 1.942 0 018.073 6.4c0-1.071.867-1.946 1.93-1.946.29 0 .568.064.826.189a.296.296 0 00.398-.145.3.3 0 00-.143-.401 2.455 2.455 0 00-1.082-.245c-1.392 0-2.525 1.144-2.525 2.548 0 1.404 1.133 2.548 2.525 2.548s2.526-1.144 2.526-2.548c0-.381-.084-.75-.243-1.091a.296.296 0 00-.398-.145z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./public/dist/img/svg/Eye.svg